'use client';
import { useTranslations as useTranslations$1 } from 'next-intl';
import { Check, Circle } from '@/components/ui/icons';
import type { PasswordPolicy } from '@/lib/api';
import { checkPasswordPolicy, type PasswordRuleKey } from '@/lib/passwordPolicy';
import { cn } from '@/lib/utils';
interface PasswordRequirementsProps {
    password: string;
    policy: PasswordPolicy;
    className?: string;
}
/**
 * Live checklist of the active password policy's requirements. Driven by the
 * same rules the backend enforces (via checkPasswordPolicy) so the user sees
 * what's still missing before submitting.
 */ export function PasswordRequirements({ password, policy, className }: PasswordRequirementsProps) {
    const t = useTranslations$1();
    const { rules } = checkPasswordPolicy(password, policy);
    const labelFor = (key: PasswordRuleKey, minLength?: number): string =>{
        switch(key){
            case 'minLength':
                return t("RdiLWH", {
                    count: String(minLength ?? policy.minLength)
                });
            case 'uppercase':
                return t("x1gAXt");
            case 'lowercase':
                return t("Mbs3PJ");
            case 'number':
                return t("8jocOM");
            case 'symbol':
                return t("081mqY");
        }
    };
    return (<ul className={cn('space-y-1', className)}>
      {rules.map((rule)=>(<li key={rule.key} className="flex items-center gap-2 text-xs">
          {rule.met ? (<Check className="size-3.5 shrink-0 text-emerald-500" aria-hidden/>) : (<Circle className="size-3.5 shrink-0 text-white/30" aria-hidden/>)}
          <span className={cn(rule.met ? 'text-white/70' : 'text-white/50')}>{labelFor(rule.key, rule.minLength)}</span>
        </li>))}
    </ul>);
}
